// @ts-nocheck
import { MOCK } from "@/state/app-store";
import { UI } from "@/components/ui";
import { Icon } from "@/components/icons";
import { api } from "@/api/index";

const { $, $$, fmtNum, fmtMoney, fmtPercent, toast, confirmModal, hasPerm, statusBadge, trendArrow, statCard, channelChip, capabilityBadge, pageHeader, emptyState, primaryBtn, ghostBtn, stepIndicator, BUSINESS_COLORS, chartTooltip, chartXAxis, chartYAxis, chartLineSeries, chartBarSeries } = UI;

declare const echarts: any;
declare const Pages: Record<string, any>;
declare const PageHooks: { mounted?: ((path: string) => void) | null };
declare function navigate(path: string): void;
declare function getCurrentPath(): string;
declare function getCurrentPathWithQuery(): string;
declare function renderRoute(): void;

if (typeof window !== "undefined") {
  (window as any).Pages = (window as any).Pages || {};
}

const Pages = (window as any).Pages;

// ============================================================
// SDK 管理：下载 / 版本管理 / 集成文档 / 调试工具
// ============================================================

window.Pages = window.Pages || {};

// ---------- SDK 下载（PRD 7.6） ----------
Pages.sdkDownloads = function () {
  const platform = location.hash.split("?platform=")[1] || "android";
  const platforms = [
    { code: "android", name: "Android", icon: "🤖", ext: ".aar" },
    { code: "ios", name: "iOS", icon: "🍎", ext: ".framework" },
    { code: "unity", name: "Unity", icon: "🎮", ext: ".unitypackage" },
    { code: "unreal", name: "Unreal", icon: "🔷", ext: ".plugin" },
    { code: "cocos", name: "Cocos", icon: "⚙️", ext: ".js" },
  ];
  const versions = MOCK.SDK_VERSIONS.filter((v) => v.platform.toLowerCase() === platform);
  const latest = versions.find((v) => v.recommended) || versions[0];

  return `
    ${UI.pageHeader({
      title: "SDK 下载中心",
      desc: "选择平台下载最新版本的 EasyShare SDK",
    })}

    <!-- 平台 Tab -->
    <div class="card p-1.5 mb-4 inline-flex">
      ${platforms
        .map(
          (p) => `
        <a href="#/dev/sdk-downloads?platform=${p.code}" class="px-4 py-2 rounded-lg text-sm font-medium ${platform === p.code ? "bg-brand-500 text-white shadow" : "text-ink-700 hover:bg-ink-50"}">
          <span class="mr-1">${p.icon}</span>${p.name}
        </a>
      `,
        )
        .join("")}
    </div>

    ${
      latest
        ? `
      <!-- 最新版本 -->
      <div class="bg-gradient-to-br from-brand-700 to-brand-900 border border-brand-800 rounded-2xl p-6 text-white relative overflow-hidden mb-4 shadow-soft">
        <div class="absolute -right-8 -bottom-8 text-9xl opacity-10">${platforms.find((p) => p.code === platform)?.icon}</div>
        <div class="relative">
          <div class="flex items-center gap-2 text-xs opacity-80">
            <span>最新版本</span>
            ${latest.recommended ? '<span class="px-2 py-0.5 bg-white/20 rounded-full">推荐</span>' : ""}
          </div>
          <div class="text-3xl font-bold mt-1">${latest.version}</div>
          <div class="text-xs opacity-80 mt-1">发布于 ${latest.date} · ${latest.size}</div>

          <div class="mt-4 bg-white/10 rounded-lg p-4 backdrop-blur">
            <div class="text-xs uppercase tracking-wide opacity-80 mb-2">更新内容</div>
            <ul class="text-sm space-y-1">
              ${latest.changes.map((c) => `<li class="flex gap-2"><span>•</span><span>${c}</span></li>`).join("")}
            </ul>
            ${latest.breaking ? `<div class="mt-3 px-3 py-1.5 bg-red-500/30 rounded text-xs">⚠️ 包含 Breaking Changes，升级前请阅读迁移指南</div>` : ""}
          </div>

          <div class="mt-5 flex flex-wrap gap-2">
            <button onclick="UI.toast('开始下载 ${latest.version}', 'success')" class="px-4 py-2 bg-white text-brand-700 rounded-lg text-sm font-medium hover:bg-brand-50">
              📥 下载 ${platforms.find((p) => p.code === platform)?.ext}
            </button>
            <button onclick="navigate('/dev/sdk-docs')" class="px-4 py-2 bg-white/15 text-white rounded-lg text-sm font-medium hover:bg-white/25">📖 集成文档</button>
            <button class="px-4 py-2 bg-white/15 text-white rounded-lg text-sm font-medium hover:bg-white/25">💻 示例代码</button>
            <button onclick="navigate('/dev/sdk-debug')" class="px-4 py-2 bg-white/15 text-white rounded-lg text-sm font-medium hover:bg-white/25">🧪 调试工具</button>
          </div>
        </div>
      </div>
    `
        : `
      <div class="card p-12 text-center">
        <div class="text-5xl mb-3">📦</div>
        <div class="text-base font-semibold">该平台暂无可用版本</div>
        <div class="text-sm text-ink-500 mt-1">${platforms.find((p) => p.code === platform)?.name} SDK 即将上线</div>
      </div>
    `
    }

    <!-- 历史版本 -->
    ${
      versions.length > 1
        ? `
      <div class="card overflow-hidden">
        <div class="px-5 py-4 border-b border-ink-100">
          <h3 class="text-sm font-semibold">历史版本</h3>
        </div>
        <div class="divide-y divide-ink-100">
          ${versions
            .filter((v) => !v.recommended)
            .map(
              (v) => `
            <div class="px-5 py-4 flex items-center gap-4">
              <div class="flex-1">
                <div class="flex items-center gap-2">
                  <span class="font-mono text-sm font-medium">${v.version}</span>
                  ${UI.statusBadge(v.status)}
                  ${v.breaking ? '<span class="badge bg-red-50 text-red-700">Breaking</span>' : ""}
                </div>
                <div class="text-xs text-ink-500 mt-1">${v.date} · ${v.size} · ${v.changes.join(" / ")}</div>
              </div>
              <button class="px-3 py-1.5 text-xs border border-ink-100 rounded-lg hover:bg-ink-50">下载</button>
              <button class="px-3 py-1.5 text-xs border border-ink-100 rounded-lg hover:bg-ink-50">更新日志</button>
            </div>`,
            )
            .join("")}
        </div>
      </div>
    `
        : ""
    }
  `;
};

// ---------- 版本管理（IA 状态机） ----------
Pages.sdkVersions = function () {
  if (!UI.hasPerm("admin")) {
    return UI.emptyState({ icon: "🔒", title: "权限不足", desc: "仅 SDK 管理员可访问版本管理", action: `<button onclick="navigate('/dev/sdk-docs')" class="px-4 py-2 bg-brand-500 text-white rounded-lg text-sm">前往下载页</button>` });
  }
  return `
    ${UI.pageHeader({
      title: "SDK 发布中心",
      desc: "平台级 SDK 版本发布、推荐、废弃与兼容性治理（仅 SDK 管理员）",
      actions: `<button onclick="confirmAction('发布新 SDK 版本', '确定要创建并发布一个新的 SDK 版本吗？发布前请确认版本号、变更说明和兼容性标记。', '确认发布', '已创建 SDK 发布任务', '', 'info')" class="px-3 py-1.5 text-sm bg-brand-500 text-white rounded-lg hover:bg-brand-600">+ 发布新版本</button>`,
    })}

    <!-- 状态机说明 -->
    <details class="bg-ink-50 rounded-lg mb-4">
      <summary class="px-4 py-3 flex items-center gap-2 cursor-pointer text-sm">
        <svg class="chev w-3 h-3 text-ink-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
        <span class="font-medium">SDK 版本生命周期</span>
        <span class="text-xs text-ink-500 ml-2">开发中 → 测试中 → 待发布 → 已发布 → 推荐 / 废弃 → 删除</span>
      </summary>
      <div class="px-4 pb-4">
        <div class="flex items-center gap-1 text-xs">
          ${["开发中", "测试中", "待发布", "已发布", "推荐版本"].map((s, i) => `
            <span class="px-3 py-1.5 ${i === 4 ? "bg-emerald-100 text-emerald-700" : i === 3 ? "bg-brand-100 text-brand-700" : "bg-white border border-ink-100 text-ink-700"} rounded-lg font-medium">${s}</span>
            ${i < 4 ? '<span class="text-ink-300">→</span>' : ""}
          `).join("")}
        </div>
      </div>
    </details>

    <!-- 版本表格 -->
    <div class="card overflow-hidden">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center gap-3">
        <select class="text-sm border border-ink-100 rounded-lg px-2.5 py-1.5 bg-white">
          <option>全部平台</option>
          <option>Android</option>
          <option>iOS</option>
          <option>Unity</option>
        </select>
        <select class="text-sm border border-ink-100 rounded-lg px-2.5 py-1.5 bg-white">
          <option>全部状态</option>
          <option>已发布</option>
          <option>测试中</option>
          <option>已废弃</option>
        </select>
      </div>
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-4 py-2.5 font-medium">版本</th>
            <th class="text-left px-4 py-2.5 font-medium">平台</th>
            <th class="text-left px-4 py-2.5 font-medium">状态</th>
            <th class="text-left px-4 py-2.5 font-medium">发布时间</th>
            <th class="text-left px-4 py-2.5 font-medium">体积</th>
            <th class="text-left px-4 py-2.5 font-medium">采用率</th>
            <th class="text-right px-4 py-2.5 font-medium">操作</th>
          </tr>
        </thead>
        <tbody>
          ${MOCK.SDK_VERSIONS.map((v) => {
            const adoption = v.recommended ? Math.floor(Math.random() * 30) + 60 : v.status === "testing" ? Math.floor(Math.random() * 5) : Math.floor(Math.random() * 30);
            return `
            <tr class="border-t border-ink-100 row-hover">
              <td class="px-4 py-3">
                <div class="flex items-center gap-2">
                  <span class="font-mono font-medium">${v.version}</span>
                  ${v.recommended ? '<span class="badge bg-emerald-100 text-emerald-700">⭐ 推荐</span>' : ""}
                  ${v.breaking ? '<span class="badge bg-red-50 text-red-700">Breaking</span>' : ""}
                </div>
              </td>
              <td class="px-4 py-3">${v.platform}</td>
              <td class="px-4 py-3">${UI.statusBadge(v.status)}</td>
              <td class="px-4 py-3 text-ink-500 text-xs">${v.date}</td>
              <td class="px-4 py-3 text-xs">${v.size}</td>
              <td class="px-4 py-3">
                <div class="flex items-center gap-2">
                  <div class="flex-1 h-1.5 bg-ink-100 rounded-full overflow-hidden">
                    <div class="h-full bg-brand-500" style="width:${adoption}%"></div>
                  </div>
                  <span class="text-xs text-ink-700 font-medium">${adoption}%</span>
                </div>
              </td>
              <td class="px-4 py-3 text-right">
                <button class="text-xs text-brand-500 hover:underline mr-2">查看</button>
                <button class="text-xs text-ink-500 hover:underline mr-2">Diff</button>
                <button class="text-xs text-red-500 hover:underline">${v.recommended ? "" : "废弃"}</button>
              </td>
            </tr>`;
          }).join("")}
        </tbody>
      </table>
    </div>
  `;
};

// ---------- 集成文档 ----------
Pages.sdkDocs = function () {
  return `
    ${UI.pageHeader({ title: "SDK 集成文档", desc: "10 分钟集成 EasyShare SDK 到你的游戏" })}

    <div class="grid grid-cols-4 gap-4">
      <!-- 侧边导航 -->
      <div class="card p-4 sticky top-2 self-start">
        <div class="text-xs font-semibold text-ink-500 mb-2 uppercase">快速导航</div>
        <ul class="space-y-1 text-sm">
          ${[
            "1. 准备工作",
            "2. 集成 SDK",
            "3. 初始化",
            "4. 调用分享",
            "5. 上报事件",
            "6. 处理回调",
            "7. 测试与上线",
            "8. 常见问题",
          ]
            .map(
              (t, i) => `
            <li><a href="#step-${i}" class="block px-2 py-1.5 rounded hover:bg-ink-50 ${i === 3 ? "bg-brand-50 text-brand-600 font-medium" : "text-ink-700"}">${t}</a></li>
          `,
            )
            .join("")}
        </ul>
      </div>

      <!-- 文档主体 -->
      <div class="col-span-3 card p-8">
        <h2 class="text-xl font-bold text-ink-900">EasyShare SDK · iOS 集成文档</h2>
        <p class="text-sm text-ink-500 mt-1">v2.4.0 · 适用于 iOS 13+</p>

        <div class="bg-brand-50 border border-brand-200 rounded-md p-4 mt-6 mb-5 text-sm text-brand-900">
          <div class="font-semibold mb-1">凭证规则</div>
          <div>同一款游戏下的所有包体共用同一个 <code class="font-mono">GameID</code> 和 <code class="font-mono">Game Secret</code>。包体只用于区分 Region × Platform，不单独生成 Game Secret。</div>
        </div>

        <h3 class="text-base font-semibold text-ink-900 mt-6 mb-3">3. 初始化 SDK</h3>
        <p class="text-sm text-ink-700 mb-3">客户端使用游戏级 GameID 与包体级 RippleID 初始化；Game Secret 仅在服务端签名时使用，不要放入客户端代码。</p>
        <div class="bg-ink-900 rounded-lg overflow-hidden mb-6">
          <div class="flex items-center justify-between px-4 py-2 bg-ink-700/50">
            <span class="text-xs text-ink-100">Swift</span>
            <button onclick="UI.toast('代码已复制', 'success')" class="text-xs text-ink-300 hover:text-white">📋 复制</button>
          </div>
          <pre class="p-4 text-xs text-ink-100 font-mono overflow-x-auto leading-relaxed"><code><span class="text-purple-300">import</span> EasyShareSDK

<span class="text-yellow-200">EasyShareSDK</span>.initialize(
    gameID: <span class="text-emerald-300">"game_xxxxxxxxxxxxxxxx"</span>,
    rippleID: <span class="text-emerald-300">"p_a1b2c3d4e5f6"</span>,  <span class="text-ink-300">// 包体级 Ripple ID，区分 Region × Platform</span>
    environment: .production
)</code></pre>
        </div>

        <h3 class="text-base font-semibold text-ink-900 mt-6 mb-3">4. 调用分享功能</h3>

        <p class="text-sm text-ink-700 mb-3">客户端只需要传入运营后台发布的 <code class="font-mono">ConfigID</code>；SDK 会在该 ConfigID 下读取已发布的 CardID + LandingPageID 组合。</p>

        <div class="bg-brand-50 border border-brand-200 rounded-md p-4 mb-4 text-sm text-brand-900">
          <div class="font-semibold mb-1">运行时选择逻辑</div>
          <div class="text-xs leading-relaxed">同一包体可关联多个并行 ConfigID，不存在优先级；客户端本次传入哪个 ConfigID，SDK 就只在该 ConfigID 下读取对应的 CardID + LandingPageID 组合。CardID 决定渠道内展示，LandingPageID 决定点击后的落地页。</div>
        </div>

        <div class="bg-ink-900 rounded-lg overflow-hidden">
          <div class="flex items-center justify-between px-4 py-2 bg-ink-700/50">
            <span class="text-xs text-ink-100">Swift</span>
            <button onclick="UI.toast('代码已复制', 'success')" class="text-xs text-ink-300 hover:text-white">📋 复制</button>
          </div>
          <pre class="p-4 text-xs text-ink-100 font-mono overflow-x-auto leading-relaxed"><code><span class="text-purple-300">import</span> EasyShareSDK

<span class="text-yellow-200">EasyShareSDK</span>.share(
    configID: <span class="text-emerald-300">"cfg_pkg_001"</span>,      <span class="text-ink-300">// 运营发布的分享内容配置 ID</span>
    channel: .facebook,             <span class="text-ink-300">// 可选，nil 则弹出系统分享面板</span>
    onSuccess: { result <span class="text-purple-300">in</span>
        <span class="text-purple-300">print</span>(<span class="text-emerald-300">"Shared to \\(result.channel) with cardID: \\(result.cardID)"</span>)
    },
    onFailure: { error <span class="text-purple-300">in</span>
        <span class="text-purple-300">print</span>(<span class="text-emerald-300">"Share failed: \\(error)"</span>)
    }
)</code></pre>
        </div>

        <h3 class="text-base font-semibold text-ink-900 mt-8 mb-3">5. 上报游戏内事件</h3>

        <p class="text-sm text-ink-700 mb-3">在用户完成关键行为时调用，让 8 层漏斗追踪生效：</p>

        <div class="bg-ink-900 rounded-lg overflow-hidden">
          <div class="flex items-center justify-between px-4 py-2 bg-ink-700/50">
            <span class="text-xs text-ink-100">Swift</span>
            <button class="text-xs text-ink-300 hover:text-white">📋 复制</button>
          </div>
          <pre class="p-4 text-xs text-ink-100 font-mono overflow-x-auto leading-relaxed"><code><span class="text-ink-300">// 用户注册时</span>
<span class="text-yellow-200">EasyShareSDK</span>.trackEvent(.<span class="text-cyan-300">register</span>, userID: <span class="text-emerald-300">"user_123"</span>)

<span class="text-ink-300">// 完成新手引导</span>
<span class="text-yellow-200">EasyShareSDK</span>.trackEvent(.<span class="text-cyan-300">tutorial</span>, userID: <span class="text-emerald-300">"user_123"</span>)

<span class="text-ink-300">// 首次付费</span>
<span class="text-yellow-200">EasyShareSDK</span>.trackEvent(
    .<span class="text-cyan-300">purchase</span>,
    userID: <span class="text-emerald-300">"user_123"</span>,
    amount: <span class="text-orange-300">9.99</span>,
    currency: <span class="text-emerald-300">"USD"</span>
)</code></pre>
        </div>

        <!-- 注意事项 -->
        <div class="mt-6 bg-amber-50 border border-amber-200 rounded-lg p-4">
          <div class="text-sm font-semibold text-amber-900 mb-1">⚠️ 注意事项</div>
          <ul class="text-xs text-amber-800 space-y-1 mt-2 list-disc ml-4">
            <li>iOS 14+ 需在 Info.plist 配置 <code>LSApplicationQueriesSchemes</code> 才能唤起目标 App</li>
            <li>分享前请确保落地页 URL 已正确埋设 OG meta（title / description / image）</li>
            <li>修改图片后请使用版本号参数避免 CDN 缓存：<code>image.png?v=20240515</code></li>
            <li>WhatsApp / Facebook crawler 缓存最长 24h，可在管理后台「调试工具」主动刷新</li>
          </ul>
        </div>

        <!-- 切换语言 -->
        <div class="mt-8 pt-6 border-t border-ink-100 flex items-center justify-between">
          <div class="text-xs text-ink-500">📚 文档版本：v2.4.0 · 最后更新 2026-05-10</div>
          <div class="flex gap-1">
            ${["Swift", "Objective-C", "Java", "Kotlin", "C#"]
              .map(
                (l, i) => `<button class="px-2.5 py-1 text-xs ${i === 0 ? "bg-brand-50 text-brand-600 font-medium" : "text-ink-500 hover:bg-ink-50"} rounded">${l}</button>`,
              )
              .join("")}
          </div>
        </div>
      </div>
    </div>
  `;
};

// ---------- 调试工具 ----------
Pages.sdkDebug = function () {
  PageHooks.mounted = () => {
    // 模拟实时事件流
    const stream = document.getElementById("event-stream");
    if (!stream) return;
    let counter = 0;
    const events = [
      { ev: "Share", channel: "Facebook", user: "user_a_3219", refCode: "ref_a9f3ce2b8d", color: "brand" },
      { ev: "Click", channel: "Facebook", refCode: "ref_a9f3ce2b8d", color: "blue" },
      { ev: "Install", channel: "Facebook", user: "user_b_8842", refCode: "ref_a9f3ce2b8d", color: "green" },
      { ev: "Register", channel: "Facebook", user: "user_b_8842", refCode: "ref_a9f3ce2b8d", color: "green" },
      { ev: "Share", channel: "Discord", user: "user_c_9921", refCode: "ref_d3a8b2c1f9", color: "brand" },
      { ev: "Click", channel: "WhatsApp", refCode: "ref_e7f4a1b2c3", color: "blue" },
      { ev: "Tutorial", channel: "Twitter", user: "user_d_1029", refCode: "ref_f8d2e3a1b9", color: "amber" },
      { ev: "Purchase", channel: "Discord", user: "user_e_2210", refCode: "ref_g1h2i3j4k5", amount: 9.99, color: "rose" },
    ];
    const colors = { brand: "border-brand-500 bg-brand-50/40", blue: "border-blue-500 bg-blue-50/40", green: "border-emerald-500 bg-emerald-50/40", amber: "border-amber-500 bg-amber-50/40", rose: "border-rose-500 bg-rose-50/40" };
    const tick = () => {
      const e = events[counter % events.length];
      counter++;
      const t = new Date().toLocaleTimeString("zh-CN", { hour12: false });
      const html = `
        <div class="border-l-4 ${colors[e.color]} pl-3 py-2 rounded-r-lg text-xs animate-pulse">
          <div class="flex items-center gap-2">
            <span class="text-ink-300 font-mono">${t}</span>
            <span class="font-semibold text-ink-900">${e.ev}</span>
            <span class="text-ink-500">→</span>
            <span>${e.channel}</span>
            ${e.user ? `<span class="font-mono text-ink-500 ml-1">${e.user}</span>` : ""}
            ${e.amount ? `<span class="ml-auto font-semibold text-emerald-500">+ $${e.amount}</span>` : ""}
          </div>
          <div class="text-[10px] text-ink-300 font-mono mt-0.5">${e.refCode}</div>
        </div>
      `;
      stream.insertAdjacentHTML("afterbegin", html);
      while (stream.children.length > 12) stream.lastChild.remove();
      // 取消 pulse
      setTimeout(() => stream.firstChild?.classList.remove("animate-pulse"), 600);
    };
    tick();
    Pages.__streamTimer && clearInterval(Pages.__streamTimer);
    Pages.__streamTimer = setInterval(tick, 1500);
  };

  return `
    ${UI.pageHeader({
      title: "SDK 调试工具",
      desc: "测试分享效果、查看实时事件上报、刷新平台缓存",
    })}

    <div class="grid grid-cols-2 gap-4">
      <!-- 测试分享 -->
      <div class="card p-5">
        <h3 class="text-sm font-semibold text-ink-900 mb-3">🧪 测试分享</h3>
        <div class="space-y-3">
          <div>
            <label class="text-xs text-ink-500">选择游戏 / 包体</label>
            <select class="w-full mt-1 px-3 py-2 border border-ink-100 rounded-lg text-sm bg-white">
              ${MOCK.PACKAGES.map((p) => {
                const g = MOCK.GAMES.find((x) => x.id === p.game_id);
                return `<option>${g?.icon} ${g?.name} / ${p.name}</option>`;
              }).join("")}
            </select>
          </div>
          <div>
            <label class="text-xs text-ink-500">选择 ConfigID</label>
            <select class="w-full mt-1 px-3 py-2 border border-ink-100 rounded-lg text-sm bg-white font-mono">
              ${MOCK.SHARE_CONFIGS.slice(0, 8)
                .map((cfg) => `<option>${cfg.config_id || cfg.id} · ${cfg.name} · ${cfg.landing_page_id}</option>`)
                .join("")}
            </select>
            <div class="text-[11px] text-ink-400 mt-1">SDK 本次只读取所选 ConfigID 下的 CardID + LandingPageID 组合。</div>
          </div>
          <div>
            <label class="text-xs text-ink-500">选择渠道</label>
            <div class="grid grid-cols-4 gap-2 mt-1">
              ${MOCK.CHANNELS.filter((c) => c.enabled)
                .slice(0, 8)
                .map(
                  (c, i) => `
                <button class="px-3 py-2 border ${i === 0 ? "border-brand-500 bg-brand-50" : "border-ink-100 hover:border-brand-300"} rounded-lg text-xs flex flex-col items-center gap-1">
                  <span class="text-base">${c.icon}</span>
                  <span class="${i === 0 ? "text-brand-600 font-medium" : ""}">${c.name}</span>
                </button>
              `,
                )
                .join("")}
            </div>
          </div>
          <button onclick="UI.toast('已按选定 ConfigID 模拟一次分享，请查看右侧事件流', 'success')" class="w-full mt-2 py-2.5 bg-brand-500 text-white rounded-lg text-sm font-medium hover:bg-brand-600">🚀 模拟一次分享</button>
        </div>
      </div>

      <!-- Crawler 缓存刷新（基于渠道字段文档痛点） -->
      <div class="card p-5">
        <h3 class="text-sm font-semibold text-ink-900 mb-3 flex items-center gap-2">
          🔄 Crawler 缓存刷新
          <span class="text-[10px] text-amber-600 bg-amber-50 px-1.5 py-0.5 rounded">极高频痛点</span>
        </h3>
        <p class="text-xs text-ink-500 mb-3">修改 OG meta 后，Facebook / WhatsApp 等爬虫会缓存旧内容。点击下方按钮主动刷新。</p>
        <div class="space-y-2">
          ${[
            { name: "Facebook Sharing Debugger", icon: "📘", api: "支持官方 API 立即刷新", btn: "刷新", color: "blue" },
            { name: "Twitter Card Validator", icon: "𝕏", api: "通过 validator URL 触发", btn: "刷新", color: "slate" },
            { name: "WhatsApp", icon: "📱", api: "无官方 API · 建议落地页带 ?v=", btn: "查看建议", color: "amber", warn: true },
            { name: "Telegram", icon: "✈️", api: "通过 instant view 测试链接刷新", btn: "刷新", color: "cyan" },
          ]
            .map(
              (s) => `
            <div class="flex items-center gap-3 p-2 rounded-lg hover:bg-ink-50 ${s.warn ? "border-l-2 border-amber-400 bg-amber-50/30" : ""}">
              <span class="text-base">${s.icon}</span>
              <div class="flex-1 min-w-0">
                <div class="text-xs font-medium text-ink-900">${s.name}</div>
                <div class="text-[10px] text-ink-500">${s.api}</div>
              </div>
              <button onclick="UI.toast('已发起 ${s.name} 缓存刷新', 'info')" class="px-2.5 py-1 text-xs ${s.warn ? "bg-amber-50 text-amber-700" : "bg-brand-50 text-brand-600"} rounded hover:opacity-80">${s.btn}</button>
            </div>
          `,
            )
            .join("")}
        </div>
      </div>

      <!-- 实时事件流（PRD 4.6 调试工具） -->
      <div class="col-span-2 card p-5">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold text-ink-900 flex items-center gap-2">
            <span class="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
            实时事件流（来自 Kafka → ClickHouse）
          </h3>
          <div class="flex items-center gap-2 text-xs">
            <select class="border border-ink-100 rounded px-2 py-1">
              <option>所有事件</option>
              ${MOCK.FUNNEL_LEVELS.map((l) => `<option>${l.name}</option>`).join("")}
            </select>
            <button class="px-2 py-1 text-ink-500 hover:bg-ink-50 rounded">⏸ 暂停</button>
          </div>
        </div>
        <div id="event-stream" class="space-y-1.5 max-h-96 overflow-y-auto"></div>
      </div>
    </div>
  `;
};

// __window_exports__
// Expose helpers for cross-page / inline onclick compatibility
